import PropTypes from 'prop-types'
import EtapForm from "../parts/EtapForm.jsx";

export const EtapZamykania = (props) => {
    return <EtapForm wiz={props.wiz} etapKey="zamykania" />
}

EtapZamykania.propTypes = {
    wiz: PropTypes.any,
}